const roundPlus = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 1V9M1 5H9" stroke="#9193AA" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
export default roundPlus;
